import { BrowserRouter, useLocation } from "react-router-dom";
import AppRoutes from "./router/AppRoutes";
import ScrollToTop from "./helpers/ScrollToTop";
import WhatsAppButton from "./pages/WhatsAppButton";
import { CartProvider } from "./context/CartContext";
const AppContent = () => {
  const location = useLocation();

  const isAdminPanel = location.pathname.startsWith("/admin-panel");
const isAdminLogin = location.pathname === "/admin-login";
  return (
    <>
    <CartProvider >
      <ScrollToTop />
      <AppRoutes />
      {!isAdminPanel && !isAdminLogin && <WhatsAppButton />}
    </CartProvider >
    </>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
};

export default App;
